import { useMount } from "app/custom-hooks/useMount";
import type React from "react";
import { useDispatch } from "react-redux";
import { getHubspotStatusThunk } from "../../store/effects/hubspot/status";

const withHubspotStatusCall = <T extends Record<string, unknown>>(Component: React.ComponentType<T>) => {
    return function(props: T) {
        const dispatch = useDispatch();

        useMount(() => {
            dispatch(getHubspotStatusThunk());
        });

        return <Component {...props} />;
    };
};

export default withHubspotStatusCall;
